import React, { useEffect, useState } from 'react';
import {
  Card,
  CardHeader,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Spinner
} from 'reactstrap';
import { deleteTrackingPanel } from 'service/trackingPanel.service';
import { updateTrackingPanel } from 'service/trackingPanel.service';
import { addTrackingPanel } from 'service/trackingPanel.service';
import { getTrackingPanels } from 'service/trackingPanel.service';



const TrackingPanel = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [offerTypeData, setOfferTypeData] = useState([]);
  const [newOfferType, setNewOfferType] = useState({
   tracking_panel_name: '',
   tracking_panel_postback: '',
    id: 0,
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  useEffect(() => {
    fetchOfferTypes();
  }, []);

  const toggleModal = () => {
    setIsUpdate(false);
    setIsSubmitting(false);
    setNewOfferType({ tracking_panel_name: '', tracking_panel_postback: ''});
    setModalOpen(!modalOpen);
  };

  const toggleUpdateModal = (offertype) => {
    setNewOfferType(offertype);
    setIsSubmitting(false);
    setIsUpdate(true);
    setModalOpen(!modalOpen);
  };

  const fetchOfferTypes = async () => {
    try {
      const offertype = await getTrackingPanels();
      console.log(offertype);
      setOfferTypeData(offertype.data.panelFeed);
    } catch (error) {
      console.error('Error fetching advertisers:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOfferType((prevData) => ({ ...prevData, [name]: value }));

    

    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  
  };

//   const generateShortName = (text) => {
//     const words = text.trim().split(' ');
//     let initials = '';

//     if (words.length === 1) {
//       const word = words[0].toUpperCase();
//       if (word.length >= 2) {
//         initials = word.substring(0, 2);
//       } else {
//         initials = word.padEnd(2, '_');
//       }
//     } else {
//       words.forEach((word) => {
//         initials += word.charAt(0).toUpperCase();
//       });
//     }
//     setNewOfferType((prevData) => ({ ...prevData, shortName: initials }));
//   };

  const handleFormSubmit =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newOfferType.tracking_panel_name.trim() === '') {
      errors.tracking_panel_name = 'Panel name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      try {
        const addedAdvertiser = await addTrackingPanel(newOfferType);
        setIsSubmitting(false);
        setOfferTypeData((prevData) => [...prevData, newOfferType]);
        setNewOfferType({ tracking_panel_name: '', tracking_panel_postback: '' });
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleFormUpdate =async (e) => {
    e.preventDefault();

    // Perform form validation
    const errors = {};
    if (newOfferType.tracking_panel_name.trim() === '') {
      errors.name = 'Panel name is required';

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    }else{
      setIsSubmitting(true);
      console.log(newOfferType);
      try {
        const addedAdvertiser = await updateTrackingPanel(newOfferType.id, newOfferType);
        setIsSubmitting(false);
        fetchOfferTypes()
        toggleModal();
      } catch (error) {
        console.error('Error adding advertiser:', error);
      }
    }


  };
  const handleDeleteOfferType = async (id) => {
    try {
      await deleteTrackingPanel(id);
      setOfferTypeData((prevData) => prevData.filter((advertiser) => advertiser.id !== id));
    } catch (error) {
      console.error('Error deleting advertiser:', error);
    }
  };

  return (
    <div className="container-fluid py-4">
      <div className="row">
        <Card>
          <CardHeader className="d-flex justify-content-between">
            <h5>Tracking Panel</h5>
            <Button color="secondary" className='btn-sm' onClick={toggleModal}>
              <i className="ni ni-fat-add" /> Add Panel
            </Button>
          </CardHeader>

          <div className="p-4">
          <Table responsive>
              <thead>
                <tr>
                  <th>Panel Name</th>
                  <th>Post Back</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {offerTypeData.map((offertype, index) => (
                  <tr key={index}>
                    <td>
                    
                  <span>{offertype.tracking_panel_name}</span>
                 
                    </td>
                    <td>{offertype.tracking_panel_postback}</td>
                  
                    <td class="text-sm">
                      <Button color='success' className=" btn btn-sm mx-3 text-white" onClick={()=>toggleUpdateModal(offertype)} >
                      <i class="fas fa-user-edit " aria-hidden="true"></i>
                      </Button>
                      <Button color='danger' className='btn btn-sm text-white'  onClick={() => handleDeleteOfferType(offertype.id)}>
                      <i class="fas fa-trash" aria-hidden="true"></i>
                      </Button>
                      </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </Card>

        <Modal isOpen={modalOpen} toggle={toggleModal} size="md">
          <ModalHeader toggle={toggleModal}>Add Panel</ModalHeader>
          <ModalBody>
            <form onSubmit={handleFormSubmit}>
              <FormGroup>
                <Label for="name">Panel Name</Label>
                <Input
                  type="text"
                  name="tracking_panel_name"
                  id="name"
                  value={newOfferType.tracking_panel_name}
                  onChange={handleInputChange}
                  invalid={!!formErrors.tracking_panel_name}
                />
                {formErrors.name && <FormFeedback>{formErrors.name}</FormFeedback>}
              </FormGroup>
              <FormGroup>
                <Label for="email">Postback Url</Label>
                <Input
                  type="text"
                  name="tracking_panel_postback"
                  value={newOfferType.tracking_panel_postback}
                  onChange={handleInputChange}
                />
              </FormGroup>
              
            </form>
          </ModalBody>
          <ModalFooter>
            { !isUpdate?
            <Button color="primary" onClick={handleFormSubmit} disabled={isSubmitting} >
            {isSubmitting ? <Spinner size="sm" color="light" /> : 'Submit'}
            </Button>
            :  <Button color="primary" onClick={handleFormUpdate} disabled={isSubmitting} >
            {isSubmitting ? <Spinner size="sm" color="light" /> : 'Update'}
            </Button>
            }
            <Button color="secondary" onClick={toggleModal}>
              Close
            </Button>
          
          </ModalFooter>
        </Modal>
      </div>
    </div>
  );
};

export default TrackingPanel;
